<template>
  <div>
    <LabelledInput label="Name">
      <b-input
        :value="value.name"
        @input="updateField('name', $event)"
      />
    </LabelledInput>

    <LabelledInput label="Select a Filter to Highlight">
      <b-select
        :value="value.filter"
        :options="haloBubbleFilterOptions"
        @input="updateField('filter', $event)"
      />
    </LabelledInput>

    <b-tabs>
      <b-tab
        title="Halo"
        active
      >
        <LabelledInput label="Show Halo">
          <b-checkbox
            :checked="value.showHalo"
            switch
            @input="updateField('showHalo', $event)"
          />
        </LabelledInput>

        <LabelledInput label="Gap Size Between Bubble and Halo">
          <b-input
            :value="value.radiusGap"
            min="0"
            type="number"
            @input="updateField('radiusGap', $event)"
          />
        </LabelledInput>

        <LabelledInput label="Stroke Visibility">
          <b-input-group>
            <b-input
              min="0"
              max="100"
              type="number"
              style="max-width: 5em;"
              :value="value.strokeOpacity*100"
              @input="updateField('strokeOpacity', $event/100)"
            />
            <b-input
              min="0"
              max="100"
              type="range"
              :value="value.strokeOpacity*100"
              @input="updateField('strokeOpacity', $event/100)"
            />
          </b-input-group>
        </LabelledInput>

        <LabelledInput label="Stroke Width">
          <b-input
            :value="value.strokeWidth"
            min="0"
            type="number"
            @input="updateField('strokeWidth', $event)"
          />
        </LabelledInput>

        <LabelledInput label="Stroke Color">
          <ColorPicker
            :value="value.strokeColor"
            @input="updateField('strokeColor', $event)"
          />
        </LabelledInput>
      </b-tab>

      <b-tab title="Pulse">
        <LabelledInput label="Show Pulse">
          <b-checkbox
            :checked="value.showPulse"
            switch
            @input="updateField('showPulse', $event)"
          />
        </LabelledInput>

        <LabelledInput label="Pulsing Duration">
          <b-input
            :value="value.pulsingDuration"
            min="0"
            type="number"
            @input="updateField('pulsingDuration', $event)"
          />
        </LabelledInput>

        <LabelledInput label="Gap Size Between Bubble and Halo">
          <b-input
            :value="value.pulsingRadiusGap"
            min="0"
            type="number"
            @input="updateField('pulsingRadiusGap', $event)"
          />
        </LabelledInput>

        <LabelledInput label="Stroke Visibility">
          <b-input-group>
            <b-input
              min="0"
              max="100"
              type="number"
              style="max-width: 5em;"
              :value="value.pulsingStrokeOpacity*100"
              @input="updateField('pulsingStrokeOpacity', $event/100)"
            />
            <b-input
              min="0"
              max="100"
              type="range"
              :value="value.pulsingStrokeOpacity*100"
              @input="updateField('pulsingStrokeOpacity', $event/100)"
            />
          </b-input-group>
        </LabelledInput>

        <LabelledInput label="Stroke Width">
          <b-input
            :value="value.pulsingStrokeWidth"
            min="0"
            type="number"
            @input="updateField('pulsingStrokeWidth', $event)"
          />
        </LabelledInput>

        <LabelledInput label="Stroke Color">
          <ColorPicker
            :value="value.pulsingStrokeColor"
            @input="updateField('pulsingStrokeColor', $event)"
          />
        </LabelledInput>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import { ColorPicker } from '@orbica/vue-modules'
import { HaloBubblesConfig } from '@/types'

const components = {
  LabelledInput,
  ColorPicker,
}

const props = {
  value: {
    type: Object as PropType<HaloBubblesConfig>,
    required: true,
  },
}

@Component({ components })
export default class HaloBubbleSettings extends Vue.extend({ props }) {
  get customBubblesGroups () {
    return this.$typedStore.primary.app.config.customBubblesGroups
  }

  get customBubblesGroupsList () {
    return Object.entries(this.customBubblesGroups)
  }

  get haloBubbleFilterOptions () {
    return [
      { text: 'None', value: null },
      ...this.customBubblesGroupsList.map(([id, { name }]) => {
        return { text: name, value: id }
      }),
    ]
  }

  updateField (field: keyof HaloBubblesConfig, value: any) {
    // create a new object with updated field
    const updatedHaloBubble = { ...this.value, [field]: value }
    this.$emit('input', updatedHaloBubble)
  }
}

</script>
